import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useDeleteStaffAvailabilityException(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const mutationFn = (staffAvailabilityExceptionId: string): Promise<AxiosResponse<null>> => {
    return client.delete(`staff-availability-exceptions/${staffAvailabilityExceptionId}/`);
  };

  return useMutation(mutationFn, {
    onSuccess: () => {
      queryClient.invalidateQueries(['staff-availability-exceptions']);
    },
  });
}
